<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="handleClose"
    width="500px"
  >
    <el-form
      ref="lForm"
      :model="lObject"
      size="small"
      :rules="rules"
      label-width="100px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item label="分类名称：" required>
            <el-input v-model="lObject.lecturerTypeName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeFrom()" btntype title="取消"></butn>
      <butn btntype="primary" @click.native="submitForm()" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus";
import rulesFactory from "@/utils/rules";
import {
  lecturerTypeInfo,
  lecturerTypeSave,
  lecturerTypeUpdate
} from "@/api/lecturertype";

// const emptyObj = Object.create(null);
export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      lObject: {},
      rules: {
        lecturerTypeName: [rulesFactory.required("请输入分类名称")]
      }
    };
  },
  methods: {
    closeFrom() {
      this.$refs["lForm"].resetFields();
      this.isShow = false;
      // 点击取消 数据重置
    },
    handleClose() {
      this.$refs["lForm"].resetFields();
      this.lObject = {};
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    info(uuid) {
      lecturerTypeInfo(uuid).then(res => {
        if (res && res.code == 0) {
          this.lObject = res.data;
        }
      });
    },
    submitForm() {
      this.$refs["lForm"].validate(valid => {
        if (valid) {
          if (!this.lObject.uuid) {
            // 新增
            lecturerTypeSave(this.lObject).then(res => {
              if (!res || res.code != 0) return;
              Bus.$emit("reload");
            });
          } else {
            //编辑
            lecturerTypeUpdate(this.lObject).then(res => {
              if (!res || res.code != 0) return;
              Bus.$emit("reload");
            });
          }
          this.closeFrom();
        }
      });
    }
  },
  created() {
    Bus.$on("addLecturer", pid => {
      this.lObject.parentId = pid;
      this.showFrom("新增分类");
    });
    Bus.$on("updateLecturer", uuid => {
      this.info(uuid);
      this.showFrom("编辑");
    });
  }
};
</script>

<style lang="scss" scoped>
.rc-dialog {
  /deep/ .form {
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item--small.el-form-item {
      margin: 0;
    }
  }
}</style
>>
